/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import {
  Checkbox,
  FormControlLabel,
  TextField,
  RadioGroup,
} from '@material-ui/core';
import { groupBy } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { ROSITableHead, PQASTableHead } from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getRosiGrid,
  getPqasGrid,
  getExportRosiGrid,
  setPaginationIndex,
} from '../Store/action';
import PaginationBox from './PaginationBox';
import exportRosiPqasPDF from './exportRosiPqasPDF';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { dispatchTableLoader } from '../../../../SharedModules/Table/store/Actions';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  PAGINATION_EMPTY_ERR,
  PAGINATION_NEGATIVE_ERR,
  PAGINATION_OVER_TOTAL_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';

const DisplayRosi = () => {
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const {
    displayObj: {
      selectedValue,
      gridPQAS: getPqasList,
      gridROSI: getRosiList,
      quarterFrom: getQuarter,
      rebateProgramName: getRebateProgramName,
      allManufacturer: manufactureName,
      manufactureWithIds: manufactureID,
      countValue,
      labelerTableData,
    },
    drugData,
    manufacturerList: resultManufacturerGrid,
  } = useSelector((state) => state?.sharedState?.RosiReducer);
  // mfg type
  const type = resultManufacturerGrid?.rebatePercentOfSpendMfgGridVO?.map(
    (obj) => obj.mfgTypeCd
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const dispatch = useDispatch();
  const [rosiGrid, setRosiGrid] = React.useState([]);
  const [rosiID, setRosiID] = React.useState();
  const [pqasGrid, setPqasGrid] = React.useState([]);
  const [isTableClaimVisible, setIsTableClaimVisible] = React.useState(true);
  const [drugNumber, setDrugNumber] = React.useState([]); 
  const [groupedPQASData, setGroupedPQASData] = React.useState({});
  const [fullScreenView1, setFullScreenView1] = React.useState(false);
  const [fullScreenView2, setFullScreenView2] = React.useState(false);

  const [errorMessages, setErrorMessages] = React.useState([]);
  const [gridApi, setGridApi] = useState(null);

  const [selectedDrugSeq, setSelectedDrugSeq] = React.useState(null);
  const paginationLength =
    selectedValue == 'Manufacturer' ? manufactureID?.length : drugData?.length;
  const [count, setCount] = React.useState(countValue);

  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(paginationLength).keys(),
  ]);
  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);

  // To handle next and previous button of pagination
  const handleClick = (type, value) => {
    setIsTableClaimVisible(false);
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      // if (value < 1 || value > paginationArray.length) {
      //   dispatch(setPaginationIndex(paginationArray.length));
      // } else {
      if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
      else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // TO handle any changes in the pagination text field
  const handleBlur = (value) => {
    setIsTableClaimVisible(false);
    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    //   dispatch(setPaginationIndex(0));

    //   setTimeout(() => {
    //     value < 1
    //       ? dispatch(setPaginationIndex(1))
    //       : dispatch(setPaginationIndex(paginationArray.length));
    //   }, 20);
    // } else {
    if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
    else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray.length)
      setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };
  // handling full screen view
  const handleFullScreenView1 = () => {
    setFullScreenView1(!fullScreenView1);
  };
  const handleFullScreenView2 = () => {
    setFullScreenView2(!fullScreenView2);
  };
  // convert mQyyyy to mm/dd/yyyy
  function convertDate(mQyyyy) {
    // Extract quarter, month, and year from the input string
    const quarter = parseInt(mQyyyy.charAt(0));
    const year = parseInt(mQyyyy.slice(-4));

    // Calculate the month based on the quarter
    const month = (quarter - 1) * 3 + 1;

    // Convert month and year to two-digit format if needed
    const monthFormatted = month.toString().padStart(2, '0');
    const yearFormatted = year.toString();

    // Combine the formatted values to form the final date string
    const dateFormatted = `${monthFormatted}/01/${yearFormatted}`;

    return dateFormatted;
  }
  const convertedDate = convertDate(getQuarter);
  const number = drugData?.map((item) => item.drugSeqNum);
  const mID = manufactureID?.map((obj) => obj.manufacturerID);
  React.useEffect(() => {
    if (drugData[count - 1]?.drugSeqNum) {
      dispatch(
        getRosiGrid({
          mfgTypeCd: type[0],
          rebateProgramCd: getRebateProgramName?.rebateProgramCd,
          mfgId:
            selectedValue == 'Manufacturer'
              ? mID.toString()
              : drugData[count - 1]?.labelerCode,
          drugSeqNum:
            selectedValue == 'Manufacturer'
              ? [0]
              : drugData[count - 1]?.drugSeqNum,
          qtr: getQuarter,
          startDate: convertedDate,
          familySeqNum: 1,
        })
      );
    }
  }, [count, drugData]);
  React.useEffect(() => {
    const data = getRosiList?.rosiPqasRosiGridVO || [];
    const sorted = [...data].sort((a, b) =>
      a.drugName > b.drugName ? 1 : b.drugName > a.drugName ? -1 : 0
    );
    setRosiGrid(sorted); 
    const drugSeqNos = sorted
      .map((item) => item.drugSeqNumber)
      .filter((d) => d != null);
    if (type?.length && drugSeqNos.length) {
      dispatch(
        getPqasGrid({
          mfgTypeCd: type[0],
          rebateProgramCd: getRebateProgramName?.rebateProgramCd,
          drugSeqNum: drugSeqNos,
          qtr: getQuarter,
          startDate: convertedDate,
        })
      );
    } 

    if (sorted.length && gridApi && gridApi.forEachNode) {
      gridApi.forEachNode((node) => {
        if (node && node.rowIndex === 0) node.setSelected(true);
      });
      const firstSeq = sorted[0]?.drugSeqNumber;
      setSelectedDrugSeq(firstSeq ?? null);
      setDrugNumber(sorted[0] ? [sorted[0]] : []);
    }
  }, [getRosiList, gridApi]);
  React.useEffect(() => {
    setRosiID(drugData[count - 1]?.labelerCode);
  }, [count]);

  const manufacturer = manufactureID?.find(
    (item) => item.manufacturerName
  )?.manufacturerID;

  const rosiName = rosiGrid?.map((obj) => obj.mfgName);
  const manuID = selectedValue == 'Manufacturer' ? manufacturer : rosiID;
  const manuNameNdc =
    labelerTableData.find((item) => item.labelerCode == manuID)?.labelerName ||
    '';
  const mName = selectedValue == 'Manufacturer' ? manufactureName : manuNameNdc;

  const onSelectionChanged = (event) => {
    const rosiData = event.api.getSelectedRows();
    const seq = rosiData?.[0]?.drugSeqNumber ?? null;
    const seqKey = seq != null ? String(seq) : null;
    setSelectedDrugSeq(seqKey);
    setDrugNumber(rosiData);
    setPqasGrid(seqKey ? groupedPQASData[seqKey] || [] : []);
  };

  const onGridReady = React.useCallback(
    (params) => {
      setGridApi(params.api);      if (params.api && rosiGrid && rosiGrid.length > 0) {
        params.api.forEachNode((node) => {
          if (node && node.rowIndex === 0) node.setSelected(true);
        }); 
        const firstSeq = rosiGrid?.[0]?.drugSeqNumber;
        const firstKey = firstSeq != null ? String(firstSeq) : null;
        setSelectedDrugSeq(firstKey);
        setDrugNumber(rosiGrid[0] ? [rosiGrid[0]] : []);
      }
    },
    [rosiGrid]
  );
  const updateLoader = (value) => dispatch(dispatchTableLoader(value));
  React.useEffect(() => {
    const raw = getPqasList?.rosiPqasReportPqasGridVOList || [];
    const normalized = raw.map((item) => ({
      ...item,
      ura: item?.ura === 0 ? 0.0 : item?.ura,
    }));
    if (normalized.length)
      normalized.sort((a, b) => a.drugSeqNumber - b.drugSeqNumber);
    const grouped = groupBy(normalized, (item) => String(item.drugSeqNumber));
    setGroupedPQASData(grouped);
    const seqToUseRaw = selectedDrugSeq ?? rosiGrid?.[0]?.drugSeqNumber ?? null;
    const seqKey = seqToUseRaw != null ? String(seqToUseRaw) : null;
    setPqasGrid(seqKey ? grouped[seqKey] || [] : []);
  }, [getPqasList, rosiGrid, selectedDrugSeq]);
  // pdf header
  const secondInfo = `Quarter: ${getQuarter}`;
  const thirdInfo = `${`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}`;
  const firstInfo = `Mfg : ${manuID}`;

  const fourthInfo = `Name: ${mName}`;
  // Custom export for PDF
  const exportAllTpPDF = async (fName) => {
    const fileName = fName || 'ROSIPQAS';
    
    try {
      updateLoader(true);
      
      const exportSourceData = (drugData && drugData.length > 0) ? drugData : rosiGrid;
      
      const labelerCodeToMfgIdMap = {};
      const labelerCodeToNameMap = {};
      if (exportSourceData && exportSourceData.length > 0) {
        exportSourceData.forEach((item) => {
          const labelerCode = item.labelerCode;
          if (labelerCode) {
            labelerCodeToMfgIdMap[labelerCode] = item.mfgId || labelerCode; 
            const labelerInfo = labelerTableData?.find((lbl) => lbl.labelerCode === labelerCode);
            labelerCodeToNameMap[labelerCode] = labelerInfo?.labelerName || labelerCode;
          }
        });
      }
      
      const options = {
        pageSize: {
          width: 1280,
          height: 700,
        },
        fileName,

        rebateProgramName: `${`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}`,
        quarter: getQuarter,
        mfgName: mName[0] || mName || '',
        mfgId: manuID,
        labelerCodeToMfgIdMap,
        labelerCodeToNameMap,
        isMultipleMfg: exportSourceData && exportSourceData.length > 1,
      };
      
      const mfgIdToDrugSeqMap = {};
      if (exportSourceData && exportSourceData.length > 0) {
        exportSourceData.forEach((item) => {
          const labelerCode = item.labelerCode;
          if (labelerCode) {
            if (!mfgIdToDrugSeqMap[labelerCode]) {
              mfgIdToDrugSeqMap[labelerCode] = [];
            }
            const seqNum = item.drugSeqNumber || item.drugSeqNum;
            if (seqNum) {
              if (Array.isArray(seqNum)) {
                mfgIdToDrugSeqMap[labelerCode].push(...seqNum);
              } else {
                mfgIdToDrugSeqMap[labelerCode].push(seqNum);
              }
            }
          }
        });
      }

      const mfgIds = Object.keys(mfgIdToDrugSeqMap);
      let allDrugSeqNumbersFromRosi = [];
      let exportRosiGridData = [];

      if (mfgIds.length > 0) {
        const apiPromises = mfgIds.map((labelerCode) => {
          const apiPayload = {
            mfgTypeCd: type[0],
            rebateProgramCd: getRebateProgramName?.rebateProgramCd,
            mfgId: labelerCode,
            drugSeqNum: mfgIdToDrugSeqMap[labelerCode],
            qtr: getQuarter,
            startDate: convertedDate,
            familySeqNum: 1,
          };
          return axios.post(serviceEndPoint.GET_ROSI_GRID, apiPayload)
            .then((response) => {
              if (response.data && response.data.rosiPqasRosiGridVO && Array.isArray(response.data.rosiPqasRosiGridVO)) {
                const drugSeqNos = response.data.rosiPqasRosiGridVO
                  .map((item) => item.drugSeqNumber)
                  .filter((seq) => seq != null);
                allDrugSeqNumbersFromRosi.push(...drugSeqNos);
                exportRosiGridData.push(...response.data.rosiPqasRosiGridVO);
              }
              return response.data;
            })
            .catch((error) => {
              return null;
            });
        });

        await Promise.all(apiPromises);
      }

      let exportPqasGridData = {};
      if (allDrugSeqNumbersFromRosi.length > 0) {
        const uniqueDrugSeqNumbers = [...new Set(allDrugSeqNumbersFromRosi)];
        const pqasPayload = {
          mfgTypeCd: type[0],
          rebateProgramCd: getRebateProgramName?.rebateProgramCd,
          drugSeqNum: uniqueDrugSeqNumbers,
          qtr: getQuarter,
          startDate: convertedDate,
        };

        await axios.post(serviceEndPoint.GET_PQAS_GRID, pqasPayload)
          .then((response) => {
            if (response.data && response.data.rosiPqasReportPqasGridVOList && Array.isArray(response.data.rosiPqasReportPqasGridVOList)) {
              const raw = response.data.rosiPqasReportPqasGridVOList;
              const normalized = raw.map((item) => ({
                ...item,
                ura: item?.ura === 0 ? 0.0 : item?.ura,
              }));
              if (normalized.length) {
                normalized.sort((a, b) => a.drugSeqNumber - b.drugSeqNumber);
              }
              exportPqasGridData = groupBy(normalized, (item) => String(item.drugSeqNumber));
            }
          })
          .catch((error) => {
          });
      }

      updateLoader(false);

      const filteredDataROSITableHead = ROSITableHead.filter(item => !item.removeColumn);
      const filteredDataPQASTableHead = PQASTableHead.filter(item => !item.removeColumn);

      const sortedExportRosiGridData = [...exportRosiGridData].sort((a, b) =>
        a.drugName > b.drugName ? 1 : b.drugName > a.drugName ? -1 : 0
      );

      exportRosiPqasPDF(
        sortedExportRosiGridData,
        filteredDataROSITableHead,
        exportPqasGridData,
        filteredDataPQASTableHead,
        userDefaults,
        options,
        logInUser
      );
    } catch (error) {
      updateLoader(false);
    }
  };
  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="ROSI/PQAS Detail Report"
      />
      <DisplayErrorMessages errorMessages={errorMessages} />
      {!fullScreenView1 && (
        <>
          <div className="row mb-5">
            <div className="col-12">
              <PaginationBox
                array={paginationArray}
                count={count}
                handleClick={handleClick}
                handleBlur={handleBlur}
              />
            </div>
          </div>
          <div className="panel custom-fieldset">
            <div className="custom-check">
              <div className="form-wrapper">
                <div div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      id="Rebate_Program"
                      label="Rebate Program"
                      fullWidth
                      placeholder=""
                      inputProps={{ id: 'Rebate_Program' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                      disabled
                    />
                  </div>
                </div>
                <div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      label="Manufacturer ID : "
                      id="Manufacturer ID"
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="Manufacturer ID"
                      value={manuID}
                      disabled
                    />
                  </div>
                </div>
                <div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      id="Quarter1"
                      label="Quarter"
                      fullWidth
                      placeholder=""
                      inputProps={{ id: 'Quarter1' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={getQuarter}
                      disabled
                    />
                  </div>
                </div>
                <div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      label="Manufacturer Name"
                      id="manufacturer Name"
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="Manufacturer Name "
                      disabled
                      value={mName}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="panel custom-fieldset">
            <div className="custom-check">
              <div className="form-wrapper">
                <div div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      id="ROSI_Information"
                      label="ROSI Information"
                      fullWidth
                      placeholder=""
                      className="mandate-fields frr-display-hidden-label"
                      inputProps={{ id: 'ROSI_Information' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value="ROSI Information"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <div
        id="testGrid"
        className="panel-body FRR-custom-table tbl-manufacturer-inner tableinIntrest"
      >
        <TableGrid
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          data-testid="ROSI-Information"
          rowSelection="single"
          countValue={count}
          rowMultiSelectWithClick={false}
          fullScreenView={fullScreenView1}
          handleFullScreenViewClick={handleFullScreenView1}
          isScrollOn
          gridHeight={fullScreenView1 ? '70vh' : viewPortHeight_355}
          rowData={rosiGrid?.map((item) => {
            return {
              ...item,
              ndc: `${item.labelerCode}-${item.productCode}-${item.packageSize}`,
              adjustedUnitRebateAmt:
                item.adjustedUnitRebateAmt === 0
                  ? '0.0000'
                  : item.adjustedUnitRebateAmt?.toFixed(4),
              adjustedUnits:
                item.adjustedUnits === 0
                  ? '0.0000'
                  : item.adjustedUnits?.toFixed(4),
              paidUnits:
                item.paidUnits === 0 ? '0.0000' : item.paidUnits?.toFixed(4),
              disputedUnits:
                item.disputedUnits === 0
                  ? '0.0000'
                  : item.disputedUnits?.toFixed(4),
              paidAmt: item.paidAmt || 0,
            };
          })}
          defaultCol={{
            wrapHeaderText: true,
            autoHeaderHeight: true,
          }}
          frameworkComponents={{
            TextBoxRender: (cellInfo) => {
              const name = cellInfo?.value;
              if (name && name.length > 20) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
          }}
          columnDefs={ROSITableHead}
          exportFile
          animateRows
          sideBar={false}
          reportName="ROSI PQAS Detail Report"
          fileName=" ROSIPQAS"
          singleClickEdit
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
          // customPDFExport={exportPDF}
          exportAllTpPDF={exportAllTpPDF}
        />
      </div>
      {!fullScreenView2 && (
        <>
          <div className="panel custom-fieldset">
            <div className="custom-check">
              <div className="form-wrapper">
                <div div className="mui-custom-form input-md">
                  <div className="col-12">
                    <TextField
                      id="PQAS_Information"
                      label="PQAS Information"
                      fullWidth
                      placeholder=""
                      className="mandate-fields frr-display-hidden-label"
                      inputProps={{ id: 'PQAS_Information' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value="PQAS Information"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {isTableClaimVisible && (
        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner"
        >
          <TableGrid
            //   ref={gridRef}
            data-testid="PQAS-Information1"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView2}
            handleFullScreenViewClick={handleFullScreenView2}
            countValue={count}
            gridHeight={fullScreenView2 ? '70vh' : viewPortHeight_355}
            isScrollOn
            rowData={pqasGrid?.map((item) => {
              return {
                ...item,
                numberOfUnits: item.numberOfUnits?.toFixed(4),
                unitsPaidToDate: item.unitsPaidToDate?.toFixed(4),
                unitsDisputedToDate: item.unitsDisputedToDate?.toFixed(4),
              };
            })}
            columnDefs={PQASTableHead}
            exportFile
            animateRows
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            sideBar={false}
            fileName="PQAS "
            reportName="PQAS Detail Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
            exportAllTpPDF={exportAllTpPDF}
          />
        </div>
      )}
    </div>
  );
};

export default DisplayRosi;
